<template>
  <div>
    <div v-if="scanner && items.length" class="row pb-3 border-bottom border-danger">
      <div class="w-100 text-center mt-3">
        <h3>ORDER BARCODE SCANNER</h3>
      </div>
      <div class="w-20 mt-4">
        <b-form-input
          class="bg-dark text-white"
          ref="ean"
          v-model="code"
          v-on:keyup.enter="scan"
          placeholder="Scan EAN code"></b-form-input>
      </div>
      <div class="w-20 mt-4 ml-3">
        <button @click="closeScanner" class="btn btn-danger px-5 py-2">
          CLOSE SCANNER <b-icon-file-break shift-h="10"></b-icon-file-break>
        </button>
      </div>
    </div>
    <div v-else class="row pb-3 border-bottom border-danger">
      <div class="w-100 text-center mt-3">
        <h3>REGOS PARTS BY INVOICE</h3>
      </div>
      <div class="w-30 mr-3">
        <span>Regos ID</span>
        <b-form-input
          style="height: 42px;"
          v-model.number="regosID"
          type="number"
          v-on:keyup.enter="getParts"
          class="bg-dark text-white"></b-form-input>
      </div>
      <div class="w-20 mt-4">
        <button @click="getParts" :class="!regosID ? 'btn-outline-danger disabled' : 'btn-success'" class="btn px-5 py-2">
          SEARCH <b-icon-search shift-h="10"></b-icon-search>
        </button>
      </div>
      <div class="w-20 mt-4 ml-3">
        <b-form-select
          style="height: 42px;"
          class=""
          placeholder="Select Box"
          v-model="location"
          :disabled="!data.regosItems.length"
          :options="shelfBoxes"></b-form-select>
      </div>
      <div class="w-20 mt-4 ml-3">
        <button @click="startScanner" :class="!data.regosItems.length || !location ? 'btn-outline-danger disabled' : 'btn-primary'" class="btn px-5 py-2">
          SCANNER <b-icon-file-break shift-h="10"></b-icon-file-break>
        </button>
      </div>
    </div>
    <div class="w-100 position-relative" v-if="loading">
      <div class="w-100 mt-5 position-absolute text-center">
        <b-icon class="text-dark" icon="arrow-clockwise" animation="spin" font-scale="3"></b-icon>
      </div>
    </div>

    <div v-if="items.length">
      <div class="row mt-3 overflow-hidden">
        <table class="table" ref="articles">
          <thead>
          <tr>
            <th scope="col">#</th>
            <th scope="col">Updated</th>
            <th scope="col">SKU</th>
            <th class="d-none d-sm-table-cell" scope="col">Name</th>
            <th class="d-none d-sm-table-cell" scope="col">Ordered</th>
            <th class="d-none d-sm-table-cell text-center" scope="col">Local</th>
            <th class="d-none d-sm-table-cell" scope="col">Scanned</th>
            <th class="d-none d-sm-table-cell text-center" scope="col">Box</th>
            <th class="d-none d-sm-table-cell" scope="col">Reduce</th>
<!--            <th class="d-none d-sm-table-cell" scope="col">Remove</th>-->
          </tr>
          </thead>
          <tbody>
            <tr v-for="(val, i) of items" v-bind:key="i" :class="[val.count === val.scanned ? 'bg-success' : 'bg-warning', 'text-dark']">
              <td :style="scanned && scanned === val.product.codename ? 'background: #dc3545; color: #ffffff' : ''">{{i+1}}</td>
              <td>{{moment(val.updatedAt).format('DD.MM.YYYY HH:mm')}}</td>
              <td>{{val.product.codename}}</td>
              <td @click="put(val._id)" class="cursor-pointer">{{val.product.name}}</td>
              <td class="text-center">{{val.count}}</td>
              <td class="text-center"><strong>{{val.local || 0}}</strong> {{val.product.localLocation ? `[${val.product.localLocation}]` : ''}}</td>
              <td class="text-center">{{val.scanned || 0}}</td>
              <td class="text-center">{{val.location || 'Not in box'}}</td>
              <td class="text-center">
                <b-button class="btn-sm" @click="backToStock(val)" :disabled="!val.scanned && !val.local">
                  <b-icon-chevron-left></b-icon-chevron-left>
                </b-button>
              </td>
<!--              <td class="text-center">-->
<!--                <b-button class="btn-sm" @click="removeItem(val)">-->
<!--                  <b-icon-chevron-double-left></b-icon-chevron-double-left>-->
<!--                </b-button>-->
<!--              </td>-->
            </tr>
          </tbody>
        </table>
      </div>
      <div v-if="data.orderedItems && data.orderedItems.length" class="row mt-3 overflow-hidden">
        <h4 class="w-100 text-center">POLAND ORDERS FOR {{regosID}}</h4>
        <table class="table">
          <thead>
          <tr>
            <th class="d-none d-sm-table-cell" scope="col">SKU</th>
            <th class="d-none d-sm-table-cell" scope="col">Name</th>
            <th class="d-none d-sm-table-cell" scope="col">Ordered</th>
            <th class="d-none d-sm-table-cell" scope="col">Packed</th>
            <th class="d-none d-sm-table-cell" scope="col">Sent</th>
            <th class="d-none d-sm-table-cell" scope="col">Received</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(row, i) of data.orderedItems" v-bind:key="i" :class="getRowClass(row)">
            <td v-b-tooltip.hover.left="row.noteType ? stripHtml(row.notes) : ''">{{row.sku}}</td>
            <td>{{row.name}}</td>
            <td>{{moment(row.addedAt).format('DD.MM.YYYY')}}</td>
            <td>{{row.packedAt ? moment(row.packedAt).format('DD.MM.YYYY'): 'N/A'}}</td>
            <td>{{row.transport && row.transport.poland ? moment(row.transport.poland).format('DD.MM.YYYY') : 'N/A'}}</td>
            <td>{{row.transport && row.transport.norway ? moment(row.transport.norway).format('DD.MM.YYYY') : 'N/A'}}</td>
          </tr>
          </tbody>
        </table>
      </div>
      <div v-else>
        <h4 class="w-100 text-center">
          No products from Poland for selected Regos ID
        </h4>
      </div>
    </div>
    <div v-else class="text-center mt-3">
      <h5>☝🏻 Enter Regos ID to get the parts list</h5>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import moment from 'moment';

import fixed from '@/fixed';
import { stripHtmlTags, getRowClass } from '@/utils';

export default {
  name: 'RegosParts.vue',
  data: () => ({
    loading: false,
    regosID: null,
    location: null,
    scanner: false,
    code: '',
    scanned: '',
    ticker: null,
    data: { regosItems: [], orderedItems: [] },
    shelfBoxes: [{ value: null, text: 'Select Box', disabled: true }],

    moment,
  }),
  mounted() {
    this.getParts();
    this.generateBoxes();
  },
  methods: {
    startScanner() {
      if (!this.data.regosItems.length || !this.location) return;

      this.scanner = true;
      this.ticker = setInterval(() => {
        this.$refs.ean.focus();
      }, 1000);
    },
    closeScanner() {
      if (this.ticker) clearInterval(this.ticker);
      this.scanned = '';
      this.scanner = false;
    },
    async getParts() {
      if (!this.regosID) return;

      this.loading = true;
      try {
        const { data } = await axios.get(`${fixed.API_URL}/admin/w-items-regos`, { params: { id: this.regosID }, withCredentials: true });
        if (!data || !data.regosItems || !data.regosItems.length) {
          this.$toast.info('No parts for that Regos ID');
          this.data = { regosItems: [], orderedItems: [] };
        } else {
          this.data = data;
        }
      } catch (error) {
        this.$toast.error('error while fetching regos parts');
      }
      this.loading = false;
    },
    async scan() {
      if (!this.code) {
        this.$toast.error('need date and code to look for');
      } else {
        // Update params
        const payload = {
          regosID: this.regosID,
          code: this.code,
          location: this.location,
        };

        try {
          const { data } = await axios.put(
            `${fixed.API_URL}/admin/scan-w-item`, payload,
            { withCredentials: true },
          );
          this.scanned = data.product.codename;
          await this.getParts();
        } catch (error) {
          if (error.response && error.response.status === 403) {
            this.$toast.error('you\'re not authorised for this action ✋🏻');
          } else {
            this.scanned = '';
            this.$toast.error(error.response.data || 'error while scanning the article');
          }
        }
      }
      this.code = '';
    },
    async put(id) {
      if (!id) return;

      const ok = confirm('Are you sure you want to confirm one of these?'); // eslint-disable-line
      if (!ok) return;

      this.loading = true;
      try {
        await axios.put(`${fixed.API_URL}/admin/put-w-item?id=${id}`, {}, { withCredentials: true });
        await this.getParts();
      } catch (error) {
        this.$toast.error(error.response.data || 'error while adding article');
      }
      this.loading = false;
    },
    async backToStock(item) {
      if (!item?.product?.codename || !this.regosID) return;

      if (item.scanned < 1 && item.local < 1) {
        this.$toast.error('article has to be scanned or in local stock in order to allow return action');
        return;
      }

      this.loading = true;
      try {
        const resp = await axios.put(`${fixed.API_URL}/admin/w-item`,
          { regosID: this.regosID, code: item.product.codename },
          { withCredentials: true });

        this.$toast.success(resp.data || 'Item returned successfully');
      } catch (error) {
        this.$toast.error(error?.response?.data || 'error while putting item back to stock');
      }
      await this.getParts();
      this.loading = false;
    },
    async removeItem(item) {
      if (!item?.product?.codename || !item.regosId) return;

      this.loading = true;
      try {
        const resp = await axios.put(`${fixed.API_URL}/admin/remove-w-item`,
          { regosID: item.regosId, code: item.product.codename },
          { withCredentials: true });

        this.$toast.success(resp.data || 'Item removed successfully');
      } catch (error) {
        this.$toast.error(error?.response?.data || 'error while removing item');
      }
      await this.getParts();
      this.loading = false;
    },
    generateBoxes() {
      for (let i = 1; i <= 50; i += 1) {
        this.shelfBoxes.push({ value: `Box${i}`, text: `Box ${i}` });
      }
    },
    stripHtml(input) {
      return stripHtmlTags(input);
    },
    getRowClass(row) {
      return getRowClass(row);
    },
  },
  computed: {
    items() {
      return this.data.regosItems.filter((item) => !item.removed);
    },
  },
};
</script>

<style scoped>
.cursor-pointer{
  cursor: pointer;
}
</style>
